import { apiBaseUrl } from '../services/apiBase';

const VISITOR_ID_KEY = 'sr_vid';
let lastTrackedPath: string | null = null;
let lastTrackedTime = 0;

function getOrGenerateVisitorId(): string {
    let vid = localStorage.getItem(VISITOR_ID_KEY);
    if (!vid || vid.length < 30) {
        vid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
        localStorage.setItem(VISITOR_ID_KEY, vid);
    }
    return vid;
}

export async function trackVisit(path?: string): Promise<void> {
    const currentPath = path || window.location.pathname;
    const now = Date.now();

    // تجنب الإرسال المكرر لطلب التتبع إذا كان نفس المسار خلال أقل من ثانيتين
    if (lastTrackedPath === currentPath && now - lastTrackedTime < 2000) {
        return;
    }

    lastTrackedPath = currentPath;
    lastTrackedTime = now;

    try {
        const vid = getOrGenerateVisitorId();
        const res = await fetch(`${apiBaseUrl}/track-visit`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Visitor-Id': vid,
            },
            body: JSON.stringify({
                path: currentPath,
                referrer: document.referrer || '',
            })
        });

        if (res.ok) {
            const data = await res.json();
            if (data?.visitor_id) {
                localStorage.setItem(VISITOR_ID_KEY, data.visitor_id);
            }
        }
    } catch {
        // أي خطأ في التتبع لا يجب أن يؤثر على المستخدم
    }
}
